import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { MasterDataRoutingModule } from './master-data.routing';
import { VaccineBatchesComponent } from './vaccine/vaccine-batches.component';
import { MedicalConditionCategoryComponent } from './medical-condition-category/medical-condition-category.component';
import { MedicalConditionComponent } from './medical-condition/medical-condition.component';
import { PrescriptionCategoryComponent } from './prescription-category/prescription-category.component';
import { PrescriptionComponent } from './presciption/prescription.component';

import { RegionListComponent } from './regions/regions-list.component';
import { CountryListComponent } from './countries/countries-list.component';

import { DiseasesListComponent } from './diseases/diseases-list.component';
import { ModifyDiseasePopupComponent } from './diseases/modify-disease-popup.component';
import { ModifyMedicalConditionComponent } from './medical-condition/modify-medical-condition-popup.component';
import { ModifyPrescriptionCategoryComponent } from './prescription-category/modify-prescription-category-popup.component';
import { ModifyPrescriptionComponent } from './presciption/modify-prescription-popup.component';
import { ModifyLabTestCategoryComponent } from './labtest-category/modify-labtest-category-popup.component';
import { CountriesDiseasesListComponent } from './countries-diseases/countries-diseases-list.component';
import { LabTestCategoryComponent } from './labtest-category/labtest-category.component';
import { LabTestDataComponent } from './lab-test-data/lab-test-data.component';
import { AddNewCountryDiseaseComponent } from './countries-diseases/add-new-country-disease.component';
import { ModifyCountryDiseaseComponent } from './countries-diseases/modify-country-disease.component';


import { SupplierListComponent } from './suppliers/suppliers-list.component';
import { ModifySupplierPopupComponent } from './suppliers/modify-supplier-popup.component';

import { ProductCategoryListComponent } from './product-categories/product-categories-list.component';
import { ModifyProductCategoryPopupComponent } from './product-categories/modify-product-category-popup.component';
import { DiseasesVaccinesListComponent } from './diseases-vaccines/diseases-vaccines-list.component';
import { AddNewDiseaseVaccineComponent } from './diseases-vaccines/add-new-disease-vaccine.component';
import { ModifyLabTestDataComponent } from './lab-test-data/modify-lab-test-data-popup.component';
import { MedicalConditionsVaccinesComponent } from './medical-conditions-vaccines/medical-conditions-vaccines-list.component';
import { ProductsListComponent } from './products/products-list.component';
import { AddNewMedicalConditionVaccineComponent } from './medical-conditions-vaccines/add-new-medical-condition-vaccine-popup.component';
import { UpdateProductPopupComponent } from './products/update-product-popup.component';
import { ModifyVaccinePopupComponent } from './vaccine/modify-vaccine-popup.component';
import { ModifyMedicalConditionCategoryComponent } from './medical-condition-category/modify-medical-condition-category-popup.component';
import { EmailDomainComponent } from './email-domain/email-domain.component';
import { ModifyEmailDomainPopupComponent } from './email-domain/modify-email-domain-popup.component';
import { ModifyConsultationsPopupComponent } from './consultations/modify-consultations-popup.component';
import { ConsultationsComponent } from './consultations/consultations.component';
import { CentreManagementFeesComponent } from './centre-management-fees/centre-management-fees.component';
import { ModifyCentreManagementFeesComponent } from './centre-management-fees/modify-centre-management-fees-popup.component';
import { ManageMemoMyTMBComponent } from './manage-memo-mytmb/manage-memo-mytmb.component';
import { QuillEditorModule } from 'ngx-quill-editor';
// import { ClinicTypeListComponent } from './clinic-types/clinic-type-list.component';
//import { ModifyClinicTypePopupComponent } from './clinic-types/modify-clinic-type-popup.component';
//import { ClinicsComponent } from './clinics/clinics.component';
//import { ReasonListComponent } from './reasons/reasons-list.component';
//import { ClinicsPopupComponent } from './clinics/clinics-popup/clinics-popup.component';
//import { ModifyReasonPopupComponent } from './reasons/modify-reasons-popup.component';
//import { ClinicScheduleComponent } from './clinic-schedule/clinic-schedule.component';
//import { PopupClinicScheduleComponent } from './clinic-schedule/popup-clinic-schedule/popup-clinic-schedule.component';

@NgModule({
  declarations: [
    VaccineBatchesComponent,
    MedicalConditionCategoryComponent,
    MedicalConditionComponent,
    PrescriptionCategoryComponent,
    RegionListComponent,
    CountryListComponent,
    DiseasesListComponent,
    ModifyDiseasePopupComponent,
    ModifyMedicalConditionComponent,
    ModifyPrescriptionCategoryComponent,
    ModifyPrescriptionComponent,
    ModifyLabTestCategoryComponent,
    SupplierListComponent,
    ModifySupplierPopupComponent,
    ProductCategoryListComponent,
    ModifyProductCategoryPopupComponent,
    PrescriptionComponent,
    PrescriptionComponent,
    CountriesDiseasesListComponent,
    LabTestCategoryComponent,
    AddNewCountryDiseaseComponent,
    ModifyCountryDiseaseComponent,
    LabTestDataComponent,
    DiseasesVaccinesListComponent,
    AddNewDiseaseVaccineComponent,
    ModifyLabTestDataComponent,
    MedicalConditionsVaccinesComponent,
    AddNewMedicalConditionVaccineComponent,
    ProductsListComponent,
    UpdateProductPopupComponent,
    ModifyVaccinePopupComponent,
    ModifyMedicalConditionCategoryComponent,
    EmailDomainComponent,
    ModifyEmailDomainPopupComponent,
    ConsultationsComponent,
    ModifyConsultationsPopupComponent,
    CentreManagementFeesComponent,
    ModifyCentreManagementFeesComponent,
    ManageMemoMyTMBComponent,
  ],
  imports: [
    MasterDataRoutingModule,
    SharedModule,
    QuillEditorModule
  ],
  entryComponents: [
    ModifyDiseasePopupComponent,
    ModifyMedicalConditionComponent,
    ModifyPrescriptionCategoryComponent,
    ModifyPrescriptionComponent,
    AddNewCountryDiseaseComponent,
    ModifyCountryDiseaseComponent,
    ModifyLabTestCategoryComponent,
    ModifySupplierPopupComponent,
    ModifyProductCategoryPopupComponent,
    AddNewDiseaseVaccineComponent,
    ModifyLabTestDataComponent,
    AddNewMedicalConditionVaccineComponent,
    UpdateProductPopupComponent,
    ModifyVaccinePopupComponent,
    ModifyMedicalConditionCategoryComponent,
    ModifyEmailDomainPopupComponent,
    ModifyConsultationsPopupComponent,
    ModifyCentreManagementFeesComponent,
  ],
  providers: [],
  bootstrap: []
})
export class MasterDataModule {
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/master-data.module.ts